import { handleActions } from 'redux-actions';
import {
  FETCH_UNIVERSITY_PENDING,
  FETCH_UNIVERSITY_SUCCESS,
  FETCH_UNIVERSITY_ERROR,
} from '../actions/university';


const defaultState = { data: JSON.parse(localStorage.getItem('university')), loading: false };

export default handleActions({
  [FETCH_UNIVERSITY_PENDING]: (state, action) => {
    return {
      data: undefined,
      loading: true,
      cancelTokenSource: action.payload.cancelTokenSource
    };
  },
  [FETCH_UNIVERSITY_SUCCESS]: (state, action) => {
    return {
      data: action.payload,
      loading: false,
      cancelTokenSource: null
    };
  },
  [FETCH_UNIVERSITY_ERROR]: (state, action) => {
    return {
      data: undefined,
      loading: false,
      error: action.payload,
      cancelTokenSource: null
    };
  }
}, defaultState)